import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Radius, Spacing, Text } from 'zens-storybook'

import { careStatusColors } from './statuscolor'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.simplyWhite,
    padding: Spacing.S,
    borderRadius: Radius.M,
    flexDirection: 'row',
    flexWrap: 'wrap',
    flexShrink: 0,
    columnGap: Spacing.L,
  },
  group: { flexShrink: 1, maxWidth: '100%' },
  items: { flexDirection: 'row', flexWrap: 'wrap' },
  item: { flexDirection: 'row', alignItems: 'center', marginHorizontal: Spacing.XS, marginVertical: Spacing.XXS },
  bar: { height: 14, width: 30, marginRight: Spacing.XS },
})

interface Props extends ViewProps {
  zoneSelected?: boolean
}

const CareLegend = ({ zoneSelected, style, ...props }: Props) => {
  const { t } = useTranslation()
  const groups = [
    {
      items: [
        { color: careStatusColors.connected, title: t('Connected') },
        { color: careStatusColors.offline, title: t('Offline or disconnected') },
        { color: careStatusColors.connectivityLost, title: t('Connectivity lost') },
        { color: careStatusColors.connectivityUnknown, title: t('Connectivity unknown') },
      ],
    },
    {
      items: [
        { color: careStatusColors.sensorDisconnected, title: t('Sensor disconnected') },
        { color: careStatusColors.ledDisconnected, title: t('LED disconnected') },
        { color: careStatusColors.sensorAndLedDisconnected, title: t('Sensor and LED disconnected') },
        { color: careStatusColors.peripheralsUnknown, title: t('Peripherals unknown') },
      ],
    },
  ]
  return (
    <View style={[styles.container, style]} {...props}>
      {groups.map(({ items }) => (
        <View style={styles.group}>
          <View style={styles.items}>
            {items.map(({ color, title }) => (
              <View key={title} style={styles.item}>
                <View style={[styles.bar, { backgroundColor: color }]} />
                <Text level={7}>{title}</Text>
              </View>
            ))}
          </View>
        </View>
      ))}
      {zoneSelected && (
        <View style={styles.item}>
          <View style={[styles.bar, { backgroundColor: careStatusColors.outsideZone }]} />
          <Text level={7}>{t('Outside selected zone')}</Text>
        </View>
      )}
    </View>
  )
}

export default CareLegend
